import { projectDetailsQuery } from '@/features/projects/queries';
import { useSuspenseQuery } from '@tanstack/react-query';
import { useParams } from '@tanstack/react-router';

export function useProjectView() {
  const { projectId } = useParams({ from: '/_authed/project/$projectId' });
  const { data: project } = useSuspenseQuery(projectDetailsQuery(projectId));
  return project.companyId ? 'supplier' : 'client';
}
